import { 
    createSlice, 
    createAsyncThunk,  
    createEntityAdapter,
    createSelector,  
} from '@reduxjs/toolkit'
import { Pager } from '../../../lib/js-apiclient/src/response/Pager';
import { FarfetchModel } from '../models/farfetch/FarfetchModel';


const farfetchCategoryAdapter = createEntityAdapter({})

export const farfetchCategoryApi = {
    _model: null,
    _getToken: (thunkAPI) => {
        return thunkAPI.getState().identityReducer.token.signature;
    },
    fetchAll: createAsyncThunk(
        'farfetch/category/fetchAll', 
        async ({channelId, genderId, page, term, parentId}, thunkAPI) => {
            try {
                const token = farfetchCategoryApi._getToken(thunkAPI);
                const farfetchModel = new FarfetchModel(token, channelId);

                const result = await farfetchModel.getCategories(genderId, page, term, parentId);
                // /** @type {Pager} */
                // const pager = await farfetchModel.getCategories(genderId, page, term);
                
                return {
                    hasPrevPage: page ? result.hasPrevPage : true,
                    hasNextPage: page ? result.hasNextPage : true,
                    entities: page ? result.getEntities() : result
                }
            } catch (apiError) {
                console.error(apiError)
                return thunkAPI.rejectWithValue(apiError.toJson());
            }
        }
    ),
}

const farfetchCategorySlice = createSlice({
    name: "farfetch/category",
    initialState: farfetchCategoryAdapter.getInitialState({
        status: 'idle',
        error: null,
        showMore: true,
    }),
    reducers: {
        clearCategoryList(state, action) {
            farfetchCategoryAdapter.removeAll(state);
        },
    },
    extraReducers: {
        [farfetchCategoryApi.fetchAll.fulfilled]: (state, action) => {
            state.status = 'farfetch/category/fetchAll/succeeded'

            if(action.payload.hasPrevPage) {
                farfetchCategoryAdapter.addMany(state, action.payload.entities)
            } else {
                farfetchCategoryAdapter.setAll(state, action.payload.entities)
            }

            state.showMore = action.payload.hasNextPage;
            state.error = null;
        },
        [farfetchCategoryApi.fetchAll.rejected]: (state, action) => {
            state.status = 'farfetch/category/fetchAll/rejected'
            state.error = action.payload
        },
    }
});

// export const selectFarfetchCategories = createSelector(
//     (state, _) => selectAllFarfetchCategories(state),
//     (_, filter) => filter,
//     (items, filter) => {
//         return (filter !== undefined && filter !== null && filter !== null) 
//             ? items.filter((item) => {
//                 return item.name.startsWith(filter);
//               })
//             : items
//     }
//   );

export const {
    selectAll: selectAllFarfetchCategories,
} = farfetchCategoryAdapter.getSelectors((state) => state.farfetchCategoryReducer)

export const { clearCategoryList } = farfetchCategorySlice.actions;

export default farfetchCategorySlice.reducer;
